module.exports = __webpack_public_path__ + "static/affiche-1c41ff1a2e2d0455be76c90d24804199.jpg";